import React, { useState } from "react";

import { useDispatch } from "~/Action";
import * as Button from "~/Button";
import { Input } from "~/Input";
import * as Layout from "~/Layout";

import * as Action from "./Action";

export * as Action from "./Action";
export * as Request from "./Request";

export namespace State {
  export type State = string;
  export const initial = (): State => "";
}

export const Component: React.Fn = () => {
  const [message, setMessage] = useState({ text: "" });
  const dispatch = useDispatch();

  const onMessageEnter = (event: React.ChangeEvent<HTMLInputElement>) =>
    setMessage({ text: event.target.value });

  const onSend = () =>
    setMessage((prevState) => {
      dispatch(Action.Requested.create(prevState.text));
      return {
        ...prevState,
        ...{
          text: "",
        },
      };
    });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "2em",
        height: "10vh",
      }}
    >
      <Input
        placeholder="message"
        value={message.text}
        onChange={onMessageEnter}
        style={{
          width: "75%",
          display: "inline",
          marginRight: "0.6em",
        }}
      />
      <Layout.Inline.Component all>
        <Button.Component
          title="Send"
          icon="$icon_send_plane_fill"
          action
          primary
          disabled={message.text.length < 1}
          onClick={onSend}
        />
      </Layout.Inline.Component>
    </div>
  );
};
